<template>
  <div class="start-station m_l16">
    <el-button type="primary" class="start-station-btn" @click="visible = true">
      <xin-icon xin-type="function-line" class="f_s20" />
    </el-button>
    <div v-if="visible" class="float-wrap" :class="{'hide':isHideStation}" @click="visible = false">
      <ul class="tool-list" :class="{'more':toolList.length > 1}">
        <li v-for="item in toolList" :key="item.key" class="tool-btn c_pointer" @click.stop="handleClickToolItem(item)">
          <span class="icon-wrap sk-bg"><xin-icon :xin-type="item.icon" /></span>
          <el-tooltip v-if="item.tooltip" effect="light" placement="bottom" :content="item.name"><p>{{item.name}}</p></el-tooltip>
          <p v-else>{{item.name}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { XinModalService } from '@xin/xin-ui';
  import EmployeeCost from './employee-cost/employee-cost.vue';
  import {CityTreeItem} from '@/module/home/entities/city-tree-item';
  import InsuranceAndFund from './insurance-and-fund/insurance-and-fund.vue';
  import StockAward from './stock-award/stock-award.vue';
  import { toolList, TToolListItem } from './const'
  import { HomeApi } from '@/module/home/service/home-api.service';

  @Component({})
  export default class Index extends Vue {
    visible = false
    toolList = toolList.filter((i:TToolListItem)=>!i.auth || i.auth && this.permission.verify(i.auth)) //权限过滤
    cityTree: CityTreeItem[] = [];
    isHideStation = false

    /**
     * 获取当前语言
     */
    get lang() {
      return window.XinI18n ? window.XinI18n.getLangCache() : '';
    }

    @Watch('visible')
    visibleChange(){
      this.triggerBodyOverflow()
    }

    created(){
      //计算器需要用到城市
      HomeApi.getCityTree('', 1).then(result => {
        this.cityTree = result;
      });
    }

    triggerBodyOverflow(){
      const body = document.body
      if(body.classList.contains('el-popup-parent--hidden')){
        body.classList.remove('el-popup-parent--hidden')
      }else{
        body.classList.add('el-popup-parent--hidden')
      }
    }

    handleClickToolItem(item:TToolListItem){

      this.XrxsTracker.$track('a_homeClickStartStationItem','',item.key)

      switch (item.key) {
        case 'monthly-personnel-report':
          //人事月报
          localStorage.setItem('isCurrentReport', 'true');
          window.location.href = '/employee/report-detail';
          break;
        case 'attendance-setting':
          this.hideStation()
          //考勤设置
          this.handlerEnterAttendance();
          break;
        case 'employee-tool':
          this.hideStation()
          //员工成本计算
          this.openEmployCost();
          break;
        case 'payroll-tool':
          this.hideStation()
          //税前工资反推计算
          this.openEmployCost(true);
          break;
        case 'insurance-tool':
          this.hideStation()
          //社保公积金测算
          this.openInsuranceAndFund();
          break;
        case 'option-tool':
          this.hideStation()
          //期权授予计算
          this.openStockAward();
          break;
        default:
          if (item.link) {
            window.location.href = item.link;
          }
          return
      }
    }

    hideStation(){
      // setTimeout(()=>{
        this.isHideStation = true
      // },200)
    }

    showStation(){
      this.isHideStation = false
    }

    /**
     * impl-考勤设置
     */
    private handlerEnterAttendance() {
      //从快捷入口进来时 判断是否设置计薪周期
      HomeApi.getAttendanceListRenderData().then((result) => {
        const res = result.data;
        if (!res.status) {
          this.$message.error(res.message);
          return;
        }
        if (res.data && !res.data.hasPayrollSetting) {
          window.location.href = '/attendance/index';
        } else {
          window.location.href = '/attendance/settings-v2?from=index';
        }
      });
    }

    /**
     * impl-员工成本计算
     * impl-税前工资反推计算
     * @param isBeforeTax 是否是税前工资
     */
    private openEmployCost(isBeforeTax?: boolean) {
      const modal = XinModalService.create({
        xinVisible: true,
        xinComponent: EmployeeCost,
        xinComponentProps: {
          isBeforeTax: isBeforeTax,
          cityTree: this.cityTree
        },
        xinDialogProps: {
          title: isBeforeTax ? window.$xinI18n('税前工资反推计算','Home-shortcut-gongzifantuijisuan') :window.$xinI18n('员工成本计算','Home-shortcut-yaungongchengbenjisuan'),
          width: this.lang === 'en' ? '800px' : '560px',
          customClass: 'employee-cost-dialog'
        },
        xinStore: this.$store,
        xinModalFooter: [
          {
            text: window.$xinI18n('开始计算','Apply-form-kaishijisuan'),
            buttonProps: {
              type: 'primary'
            },
            onClick: (instance: any) => {
              instance.startToCalculator();
            }
          }
        ]
      });
      modal.onClose((res) => {
        this.showStation()
      });
    }

    /**
     * impl-社保公积金测算
     */
    private openInsuranceAndFund() {
      const modal = XinModalService.create({
        xinVisible: true,
        xinComponent: InsuranceAndFund,
        xinComponentProps: {
          cityTree: this.cityTree
        },
        xinDialogProps: {
          title: window.$xinI18n('社保公积金测算','Home-shortcut-shebaogongjijincesuan'),
          width: this.lang === 'en' ? '800px' : '560px',
          customClass: 'employee-cost-dialog'
        },
        xinModalFooter: [
          {
            text: window.$xinI18n('开始计算','Apply-form-kaishijisuan'),
            buttonProps: {
              type: 'primary'
            },
            onClick: (instance: any) => {
              instance.startToCalculator();
            }
          }
        ]
      });
      modal.onClose((res) => {
        this.showStation()
      });
    }

    /**
     * impl-期权授予计算
     */
    private openStockAward() {
      const modal = XinModalService.create({
        xinVisible: true,
        xinComponent: StockAward,
        xinComponentProps: {},
        xinDialogProps: {
          title: window.$xinI18n('期权授予计算','Home-shortcut-qiquanjisuan'),
          width: '560px',
          customClass: 'employee-cost-dialog'
        },
        xinModalFooter: [
          {
            text: window.$xinI18n('开始计算','Apply-form-kaishijisuan'),
            buttonProps: {
              type: 'primary'
            },
            onClick: (instance: any) => {
              instance.startToCalculator();
            }
          }
        ]
      });
      modal.onClose((res) => {
        this.showStation()
      });
    }
  }
</script>

<style lang="scss" scoped>
.start-station {
  .start-station-btn{
    padding: 0;
    width: 40px;
    height: 40px;
    border-radius: 2px;
  }
  .float-wrap{
    overflow: auto;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000; //小了盖不住header
    background: rgba(0,0,0,0.3);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    transition: all .5s;
    &.hide{
      opacity: 0;
    }
    .tool-list{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin: 200px 0 300px;
      padding-top: 34px;
      display: inline-flex;
      flex-wrap: nowrap;
      height: 120px;
      background: rgba(255,255,255,0.7);
      backdrop-filter: blur(13.59px);
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      border: 1px solid var(--xs-color-white);
      li p{
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      &.more{
        padding-left: 32px;
        padding-right: 32px;
      }
      .tool-btn{
        width: 105px;
        text-align: center;
        .icon-wrap{
          margin: 0 auto 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          border-radius: 4px 4px 4px 4px;
          .xin-icon{
            color: var(--xs-color-white);
            font-size: 20px;
          }
        }
      }
    }
  }
}
::v-deep .employee-cost-dialog .el-dialog__body{
  padding: 0!important;
}
</style>
<style lang="scss">
.employee-cost-dialog .el-dialog__body{
  padding: 0!important;
}
</style>
